export default __webpack_public_path__ + "static/media/DownloadBlack.3821531e.svg";